export default "__VITE_PUBLIC_ASSET__b94e0aae__"